import React from "react";
import {Modal, Table} from "antd";
import {useTranslation} from "react-i18next";

export const AuthorizedCityUsersModal = ({visible, onClose, title, authorizedCityUsers = []}) => {
    const {t} = useTranslation(["userTypes", "common"]);

    const columns = [
        {
            title: "İsim Soyisim",
            dataIndex: "fullName",
            key: "fullName"
        },
        {
            title: "Kullanıcı Tipi",
            dataIndex: "role",
            key: "role",
            render: (text, record) => {
                return t(record?.role, {ns: "userTypes"});
            }
        },
        {
            title: "Şehir(ler)",
            dataIndex: "cities",
            key: "cities",
            render: (text, record) => {
                return (
                    record?.cities?.map(city => t(city, {ns: "common"})).join(", ") ||
                    "Tüm Şehirler"
                );
            }
        },
        {
            title: "Detay",
            dataIndex: "detail",
            key: "detail",
            render: (text, record) => {
                return (
                    <a href={`/users/${record._id}`} target="_blank" rel="noopener noreferrer">
                        Detay
                    </a>
                );
            }
        }
    ];

    return (
        <Modal
            title={title}
            visible={visible}
            onCancel={onClose}
            onOk={onClose}
            width={800}
            footer={null}
        >
            <Table
                dataSource={authorizedCityUsers || []}
                columns={columns}
                pagination={false}
                rowKey="_id"
            />
        </Modal>
    );
};
